import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { languageHelper } from "../../../config/helperFunctions";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function CreditCard() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [showDelModal, setShowDelModal] = useState(null);

  const navigate = useNavigate();

  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (sn) => sn.row.index + 1,
    },
    {
      header: languageHelper("Name") || "Name",
      accessorKey: "company_name",
    },
    {
      header: languageHelper("Discount") || "Discount",
      accessorKey: "discount_amount",
    },
    {
      header: languageHelper("Discount Type") || "Discount Type",
      accessorKey: "dis_type",
    },
    {
      header: languageHelper("Expiry Date") || "Expiry Date",
      accessorKey: "expired_date",
    },
    {
      header: languageHelper("Status") || "Status",
      accessorKey: "status",
      cell: (row) =>
        row.getValue() === "active"
          ? languageHelper("Active") || "Active"
          : row.getValue() === "inactive"
            ? languageHelper("Inactive") || "Inactive"
            : "",
    },
    {
      header: languageHelper("Actions") || "Actions",
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/multiple_payments/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.message || "Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchCreditCard();
        setShowDelModal(null);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const buttonData = [
    {
      buttonText: languageHelper("Add Credit Card"),
      path: "addEditCreditCard",
    },
  ];

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`addEditCreditCard/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => {
        setShowDelModal(id);
      },
    },
  ];

  const fetchCreditCard = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/credit_cards`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token]);

  useEffect(() => {
    setPageLoading(true);

    handleCSRF(fetchCreditCard);
  }, [fetchCreditCard]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        error={error}
        heading={languageHelper("Credit Card")}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
      {showDelModal && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
          onClick={() => setShowDelModal(null)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-[#774d96] font-semibold text-xl text-center">
                {languageHelper("Alert!") || "Alert!"}
              </h1>
              <p className="text-center text-gray-700">
                {languageHelper("Are you sure?")}
              </p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-d-bg text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setShowDelModal(false)}
              >
                {languageHelper("No") || "No"}
              </button>
              <button
                onClick={() => handleDelete(showDelModal)}
                className="bg-d-bg text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                {languageHelper("Yes") || "Yes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default CreditCard;
